import React, { useState } from 'react';
import { Typography, Box, Modal } from '@mui/material';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { GridStyled } from './style';
import {
  BMRSection,
  BMRTitle,
  BMRValue
} from '../malnutritionScreening/glim/style';
import { TypographyStyled, BoxStyled } from './style';
import { PlaceholderGrid, CutOffIcon } from '../../styles/globalStyles';
import { TextWithInfoIcon } from '../../shared/components/textWithInfoIcon';
import Line from '../../shared/components/line/index';
import improveTreatmentIcon from '../../assets/icons/improveTreatmentBlue.svg';
import InfoIcon from '../../assets/icons/infoIcon.svg';
import { ToggleButtons } from './toggleButtons';
import { AddOnInfoModal } from '../../shared/components/modal/addOnInfoModal';

export const PaediatricEPF = () => {
  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  const { summary } = useAppSelector(metaDataSelector);

  return (
    <>
      <GridStyled
        className="width-100"
        id="section-A"
        container
        sx={{ background: '#004F71', marginTop: '0px' }}
      >
        <Box
          sx={{ background: '#004F71', textAlign: 'center' }}
          className="pi-16"
        >
          <Typography
            sx={{
              fontSize: '1.125rem',
              lineHeight: '1.5rem',
              fontFamily: 'BGBold',
              fontWeight: '450',
              textTransform: 'uppercase',
              color: '#fff'
            }}
          >
            Estimated Nutritional Requirements
          </Typography>
        </Box>
        <BMRSection
          sx={{
            margin: '0px',
            flexDirection: 'column',
            alignItems: 'stretch',
            height: 'auto'
          }}
        >
          <TextWithInfoIcon
            data-testid={'paediatricPopupButton'}
            title={'Energy (kcal/day):'}
            icon={InfoIcon}
            fontSize={'1.5rem'}
            lineHeight={'1.375rem'}
            variant={'h4'}
            handleIconClick={() => handleOpen1()}
            textAlign={'left'}
          />
          <ToggleButtons name={'PAEDIATRIC_ENERGY'} />
          <BoxStyled sx={{ marginBottom: '0px' }}>
            <CutOffIcon>
              <img
                src={improveTreatmentIcon}
                alt="improveTreatmentIcon"
                style={{ width: '1.875rem' }}
              />
            </CutOffIcon>
            <PlaceholderGrid
              container
              width={'100%'}
              sx={{ background: '#F2F2F2', marginTop: '0.9375rem' }}
            >
              <TypographyStyled variant="h3">
                ENERGY(KCAL/KG/DAY):
              </TypographyStyled>
              <div style={{ width: '100%' }}>
                <BMRSection
                  sx={{
                    margin: '0px',
                    background: 'transparent',
                    width: '100%'
                  }}
                >
                  <BMRTitle variant="h2">{'EFSA for Age:'}</BMRTitle>
                  <BMRValue data-testid="prfw" sx={{ color: '#002A3A' }}>
                    {summary.paediatricEPF.energyForAgePerKg}
                  </BMRValue>
                </BMRSection>
                <Line color="#D9D9D6" height="1.5px" width="95%" />
                <BMRSection
                  sx={{
                    margin: '0px',
                    background: 'transparent',
                    width: '100%'
                  }}
                >
                  <BMRTitle variant="h2">{'EFSA for Weight:'}</BMRTitle>
                  <BMRValue data-testid="prfw" sx={{ color: '#002A3A' }}>
                    {summary.paediatricEPF.energyForWeightPerKg}
                  </BMRValue>
                </BMRSection>
              </div>
            </PlaceholderGrid>
          </BoxStyled>
        </BMRSection>
      </GridStyled>
      <>
        <GridStyled
          className="width-100"
          id="section-B"
          container
          sx={{ background: '#004F71', paddingBottom: '0px', marginTop: '0px' }}
        >
          <BMRSection
            sx={{
              margin: '0px',
              padding: '1.875rem 0.9375rem',
              flexDirection: 'column',
              alignItems: 'stretch',
              height: 'auto'
            }}
          >
            <BMRSection
              sx={{
                margin: '0px',
                width: '100%',
                padding: '0px'
              }}
            >
              <TextWithInfoIcon
                data-testid={'paediatricproteinPopup'}
                title={'Protein (g/day):'}
                icon={InfoIcon}
                fontSize={'1.5rem'}
                lineHeight={'1.375rem'}
                variant={'h4'}
                handleIconClick={() => handleOpen2()}
                textAlign={'left'}
              />
            </BMRSection>
            <ToggleButtons name={'PAEDIATRIC_PROTEIN'} />
            <BoxStyled sx={{ marginBottom: '0px' }}>
              <CutOffIcon>
                <img
                  src={improveTreatmentIcon}
                  alt="improveTreatmentIcon"
                  style={{ width: '1.875rem' }}
                  /* width="1.875rem" */
                />
              </CutOffIcon>
              <PlaceholderGrid
                container
                width={'100%'}
                sx={{ background: '#F2F2F2', marginTop: '0.9375rem' }}
              >
                <TypographyStyled variant="h3">
                  PROTEIN(G/KG/DAY):
                </TypographyStyled>
                <div style={{ width: '100%' }}>
                  <BMRSection
                    sx={{
                      margin: '0px',
                      width: '100%',
                      background: 'transparent'
                    }}
                  >
                    <BMRTitle variant="h2">{'AR (g/kg/day):'}</BMRTitle>
                    <BMRValue sx={{ color: '#002A3A' }}>
                      {summary.paediatricEPF.arPerKg}
                    </BMRValue>
                  </BMRSection>
                  <Line color="#D9D9D6" height="1.5px" width="95%" />
                  <BMRSection
                    sx={{
                      margin: '0px',
                      width: '100%',
                      background: 'transparent'
                    }}
                  >
                    <BMRTitle variant="h2">{'PRI (g/kg/day):'}</BMRTitle>
                    <BMRValue sx={{ color: '#002A3A' }}>
                      {summary.paediatricEPF.priPerKg}
                    </BMRValue>
                  </BMRSection>
                  <Line color="#D9D9D6" height="1.5px" width="95%" />
                  <BMRSection
                    sx={{
                      margin: '0px',
                      width: '100%',
                      background: 'transparent'
                    }}
                  >
                    <BMRTitle variant="h2">{'EAR (g/kg/day):'}</BMRTitle>
                    <BMRValue sx={{ color: '#002A3A' }}>
                      {summary.paediatricEPF.earPerKg}
                    </BMRValue>
                  </BMRSection>
                  <Line color="#D9D9D6" height="1.5px" width="95%" />
                  <BMRSection
                    sx={{
                      margin: '0px',
                      width: '100%',
                      background: 'transparent'
                    }}
                  >
                    <BMRTitle variant="h2">{'RNI (g/kg/day):'}</BMRTitle>
                    <BMRValue sx={{ color: '#002A3A' }}>
                      {summary.paediatricEPF.rniPerKg}
                    </BMRValue>
                  </BMRSection>
                </div>
              </PlaceholderGrid>
            </BoxStyled>
          </BMRSection>
        </GridStyled>

        <GridStyled
          className="width-100"
          id="section-C"
          container
          sx={{ background: '#004F71', marginTop: '0px' }}
        >
          <BMRSection
            sx={{
              margin: '0px',
              padding: '1.875rem 0.9375rem',
              flexDirection: 'column',
              alignItems: 'stretch',
              height: 'auto'
            }}
          >
            <BMRSection
              sx={{
                margin: '0px',
                width: '100%',
                padding: '0.3125rem',
                height: '2.5rem'
              }}
            >
              <BMRTitle variant="h2">{'Fluids (mL/day):'}</BMRTitle>
              <BMRValue>{''}</BMRValue>
            </BMRSection>
            <BMRSection sx={{ margin: '0px', width: '100%' }}>
              <BMRTitle variant="h2">{'Holiday Segar (mL/day):'}</BMRTitle>
              <BMRValue>{summary.paediatricEPF.fluidMlPerDay}</BMRValue>
            </BMRSection>
            <Line color="#D9D9D6" height="1.5px" width="95%" />
            <BMRSection sx={{ margin: '0px', width: '100%' }}>
              <BMRTitle variant="h2">{'EFSA (mL/day):'}</BMRTitle>
              <BMRValue sx={{ width: '100%', textAlign: 'right' }}>
                {summary.paediatricEPF.efsa}
              </BMRValue>
            </BMRSection>
            <Line color="#D9D9D6" height="1.5px" width="95%" />
            <BMRSection sx={{ margin: '0px', width: '100%' }}>
              <BMRTitle variant="h2">{'IOM  (mL/day):'}</BMRTitle>
              <BMRValue>{summary.paediatricEPF.iom}</BMRValue>
            </BMRSection>
            <BoxStyled sx={{ marginBottom: '0px' }}>
              <CutOffIcon>
                <img
                  src={improveTreatmentIcon}
                  alt="improveTreatmentIcon"
                  style={{ width: '1.875rem' }}
                />
              </CutOffIcon>
              <PlaceholderGrid
                container
                width={'100%'}
                sx={{ background: '#F2F2F2', marginTop: '0.9375rem' }}
              >
                <TypographyStyled variant="h3">
                  FLUIDS(ML/KG/DAY):
                </TypographyStyled>
                <div style={{ width: '100%' }}>
                  <BMRSection
                    sx={{
                      margin: '0px',
                      width: '100%',
                      background: 'transparent'
                    }}
                  >
                    <BMRTitle variant="h2">
                      {'Holiday Segar (mL/kg/day):'}
                    </BMRTitle>
                    <BMRValue sx={{ color: '#002A3A' }}>
                      {summary.paediatricEPF.fluidMlPerKgPerDay}
                    </BMRValue>
                  </BMRSection>
                </div>
              </PlaceholderGrid>
            </BoxStyled>
          </BMRSection>
        </GridStyled>
      </>
      {/* <InfoModal
        open={open1}
        onClose={handleClose1}
        title={` `}
        content={`To compare the patient's requirements to our nutritional products, please select one of the following energy results`}
      /> */}
      <Modal
        open={open1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddOnInfoModal
          heading1={`EFSA`}
          description1={` = European Food Safety Authority`}
          title={`Please Note:`}
          content={`To compare the patient's requirements to our nutritional products, please select one of the following energy results`}
          onClose={handleClose1}
        />
      </Modal>
      <Modal
        open={open2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddOnInfoModal
          heading1={`AR\u00A0\u00A0`}
          description1={` = Average Requirement`}
          heading2={`PRI\u00A0`}
          description2={` = Population Reference Intake`}
          heading3={`EAR`}
          description3={` = Estimated Average Requirement`}
          heading4={`RNI\u00A0`}
          description4={` = Reference Nutrient Intake`}
          onClose={handleClose2}
        />
      </Modal>
    </>
  );
};
